import { TokenAmount, TokenAmountProps } from '@xylabs/sdk-react'
import { useContext, useState } from 'react'

import { CurrencyBalanceContext } from '../Contexts'
import MinterAllowanceDialog from './MinterAllowanceDialog'

const MinterAllowance: React.FC<TokenAmountProps> = (props) => {
  const { minterAllowance } = useContext(CurrencyBalanceContext)
  const [allowanceDialogOpen, setAllowanceDialogOpen] = useState(false)

  const onClick = () => {
    setAllowanceDialogOpen(true)
  }

  return (
    <>
      <TokenAmount
        amount={minterAllowance}
        label="MALW"
        onClick={onClick}
        title="Minter Allowance (Total amount of XYO approved for transactions)"
        {...props}
      />
      <MinterAllowanceDialog onClose={() => setAllowanceDialogOpen(false)} open={allowanceDialogOpen} />
    </>
  )
}

export default MinterAllowance
